/* ***************************************************************************
* @author Afonso Bordado (abordado@mobinteg.com)
*******************************************************************************/

import React, { Component } from "react"
import Card from "../../components/Card"
import Spacer from "../../components/Spacer"
import styles from "./styles.css"
import * as strings from "../../strings"
import { connect } from "react-redux"
import _ from "lodash"
import { stats } from "../../actions"


import IconMenu from "react-toolbox/lib/menu/IconMenu"

import DebtPhaseEventsPie from "../../components/Charts/DebtPhaseEventPie"


class DebtPhaseEventCount extends Component {
  props: {
    name: string,
    count: number,
  }

  render () {
    return (
      <Card style={{ flex: "1", display: "flex" }}>
        <div className={styles.eventCountRoot}>
          <div className={styles.eventCountMainColumn}>
            <div className={styles.eventCountTitle}>{this.props.name}</div>
            <Spacer size={2} />
            <div className={styles.row}>
              <div className={styles.eventCountNumber}>{this.props.count}</div>
              <Spacer size={1} />
              <div className={styles.eventCountLightText}>{strings.processes.processes}</div>
            </div>
          </div>
          <div className={styles.column}>
            <IconMenu
              className={styles.eventCountIcon}
              icon="more_horiz"
              menuRipple
            />
          </div>
        </div>
      </Card>
    )
  }
}

class Dashboard extends Component {
  props: {
    auth: {
      token: string,
    }
  }

  state: {}

  componentDidMount = () => {
    stats( this.props.auth.token )
      .then( stats => this.setState( { stats } ) )
  }

  render () {
    const stats = _.chain( this.state )
      .get( "stats.result", [] )
      .groupBy( "type" )
      .mapValues( val => val.map( stat => ( {
        name: stat.state,
        value: stat.count,
      } ) ) )
      .value()

    const dataPreLitigation = _.get( stats, "preLitigation", [] )
    const dataLitigation = _.get( stats, "litigation", [] )
    const dataExecution = _.get( stats, "execution", [] )

    return (
      <div className={styles.root}>
        <div className={styles.eventCardContainer}>
          <DebtPhaseEventsPie
            name={strings.processes.preLitigation}
            data={dataPreLitigation}
          />
          <Spacer size={3}/>
          <DebtPhaseEventsPie
            name={strings.processes.injunctions}
            data={dataLitigation}
          />
          <Spacer size={3}/>
          <DebtPhaseEventsPie
            name={strings.processes.executions}
            data={dataExecution}
          />
        </div>
        <Spacer size={4}/>
        <div>
          <div className={styles.date}>
            <div className={styles.dateLine}>
              {( new Date() ).toLocaleString( "pt-PT", {
                day: "numeric",
                month: "long",
              } )}
            </div>
            <div className={styles.dateUnderline}/>
          </div>
          <Spacer size={2}/>
          <div className={styles.eventCardContainer}>
            <DebtPhaseEventCount
              name={strings.processes.preLitigation}
              count={_.sumBy( dataPreLitigation, "value" )}
            />
            <Spacer size={3}/>
            <DebtPhaseEventCount
              name={strings.processes.injunctions}
              count={_.sumBy( dataLitigation, "value" )}
            />
            <Spacer size={3}/>
            <DebtPhaseEventCount
              name={strings.processes.executions}
              count={_.sumBy( dataExecution, "value" )}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default connect( store => ( { auth: store.auth } ) )( Dashboard )



// WEBPACK FOOTER //
// ./src/views/Dashboard/index.jsx